var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{attrs:{"fluid":"","align":"center","justify":"center"}},[_c('v-col',{attrs:{"cols":"12","align":"center"}},[_c('v-card-text',{staticClass:"text-h5"},[_vm._v(_vm._s(_vm.$t("allanswerd")))])],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }